import { Marketday } from '../marketday';
import { Contact } from '../contact';
import { Salesunit } from '../salesunit';
export class Contract {
    constructor(
        public id?: number,
        public startDate?: any,
        public merchantNumber?: number,
        public marketdayNumber?: string,
        public marketdateNumber?: string,
        public endDate?: any,
        public boothWidth?: number,
        public boothDepth?: number,
        public contractNumber?: string,
        public boothWidthAdditional?: number,
        public boothDepthAdditional?: number,
        public specialPrice?: number,
        public divergentEnergy?: boolean,
        public energyAdvancedPayment?: number,
        public isSpecial?: boolean,
        public boothWidthWinter?: number,
        public boothDepthWinter?: number,
        public boothWidthWinterAdditional?: number,
        public boothDepthWinterAdditional?: number,
        public energyType?: string,
        public energyTypeWinter?: string,
        public gguid?: string,
        public marketday?: Marketday,
        public merchant?: Contact,
        public salesunit?: Salesunit,
    ) {
        this.divergentEnergy = false;
        this.isSpecial = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/contract/contract.model.ts